<template>
	<div v-show="userPermissionsFilter.viewexchangerates" :class="[companyClass, canScroll]" v-loading="pageLoading"
		element-loading-text="Loading..." element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="page-table column mb-20" :class="{ 'flex': !isMobile, 'overflow': isMobile }">
			<div class="page-header">
				<h1 class="pageTitle">Exchange Rate</h1>
				<h4></h4>
				<div id="plug">
					<div v-if="showTimer" class="v" style="color:red">We are moving this module to <a
							:href=newbackofficeurl target="_blank">New
							Backoffice</a>. This module will be permanently disabled in {{ timerOutput }}</div>
					<div v-else class="v"></div>
				</div>
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
					<el-breadcrumb-item>exhange rates</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="flex">
				<div class="flex box grow">
					<div><strong style="color:white">Running From: </strong>
						<el-date-picker type="date" placeholder="Running From" v-model="fromdate" format="dd-MM-yyyy"
							value-format="yyyy-MM-dd" v-validate="'required'" @blur="refreshExRates"
							data-vv-as="end date" style="padding-right:20px;"></el-date-picker>
					</div>
					<div><strong style="color:white">Running To: </strong>
						<el-date-picker type="date" placeholder="Running To:" v-model="todate" format="dd-MM-yyyy"
							value-format="yyyy-MM-dd" v-validate="'required'" @blur="refreshExRates"
							data-vv-as="end date" style="padding-right:20px;"></el-date-picker>
					</div>
					<!-- <el-select v-model="partnerid" @change="refreshExRates" placeholder="Partner">
						<el-option value="null" label="All">All</el-option>
						<el-option value="3" label="Transfast">Upesi</el-option>
					</el-select> -->

				</div>
				<div style="float: right;">
					<el-button v-show="userPermissionsFilter.addexchangerates" type="primary" icon="el-icon-plus"
						@click="addRate"></el-button>
				</div>
			</div>
			<br />
			<resize-observer @notify="handleResize" />
			<div class="table-responsive">
				<table class="table" id="datatable" style="color:white;">
					<thead>
						<tr>
							<th>Country</th>
							<th>From Currency</th>
							<th>To Currency</th>
							<th>Rate</th>
							<th>Running From</th>
							<th>Running To</th>
							<th>Partner</th>
							<th>Created By</th>
							<th>Created On</th>
							<!-- <th>Featured</th> -->
							<th>Approved By</th>
							<th>Approved On</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in exchangeratedata" :key="item.id">
							<td>{{ item.countryName }}</td>
							<td>{{ item.fromCurrencyName }} - {{ item.fromCurrencyCode }}</td>
							<!-- <td>{{item.fromCurrencyCodeName}}</td> -->
							<td>{{ item.toCurrencyName }} - {{ item.toCurrencyCode }}</td>
							<!-- <td>{{item.toCurrencyCodeName}}</td> -->
							<td>{{ item.rate }}</td>
							<td>{{ formatShortDate(item.runningFrom) }}</td>
							<td>{{ formatShortDate(item.runningTo) }}</td>
							<td>{{ item.partnerName }}</td>
							<td>{{ item.createdBy }}</td>
							<td>{{ formatShortDate(item.createdOn) }}</td>
							<!-- <td>{{item.featured}}</td> -->
							<td>{{ item.approvedBy }}</td>
							<td>{{ item.approvedOn }}</td>
							<td v-show="userPermissionsFilter.editexchangerates"><el-button @click="print(item)"><i
										class="mdi mdi-eye"></i></el-button>
								<!-- <el-button v-if="item.runningTo >= today" v-show="userPermissionsFilter.deleteexchangerates" type="danger" icon="el-icon-delete" -->
								<el-button v-show="userPermissionsFilter.deleteexchangerates" type="danger"
									icon="el-icon-delete" @click="deactivateRate(item.id)"></el-button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import $ from 'jquery';
import moment from 'moment-timezone'
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
	name: 'ExchangeRates',
	data: function () {
		return {
			partner: '',
			search: '',
			fromdate: moment().subtract(1, 'M').subtract(1, 'day').format('YYYY-MM-DD'),
			todate: moment().add(1, 'M').format('YYYY-MM-DD'),
			today: moment(new Date()).format('DD/MM/YYYYTHH:mm:SSSZ'),
			//today: moment().format('YYYY-MM-DDTHH:mm:SSSZ')
			exchangeratedata: '',
			partnerid: 'null',
			//IdProfile = "data:image/png;base64," + response.data;
			newbackofficeurl: "",
			countDownToTime: new Date('Oct 15, 2024 00:00:00').getTime(),
			timerOutput: '',
			showTimer: true
		}
	},
	methods: {
		addRate() {
			router.push('/addexchangerate');
		},
		deactivateRate(id) {
			this.deactivateExchangeRate(id)
				.then(result => {
					if (result) {
						this.selectedItems = [];
						this.refreshExRates();
					}
				})
		},

		// deactivateSelectedRates() {
		// 	var ids = this.selectedItems.map(p=> p.id);
		// 	this.deactivateExchangeRates(ids)
		// 	.then(result=> {
		// 		if(result){
		// 			this.selectedItems = [];
		// 			this.refreshExRates();
		// 		}
		// 	})
		// },
		print(row) {
			router.push(`/updateexchangerate/${row.id}`);
		},
		refreshExRates() {
			this.startLoader("Loading Page...");
			this.getExchangeRates(this.fromdate, this.todate)
				.then((result) => {
					$("#datatable").dataTable().fnDestroy();
					this.exchangeratedata = result.items;
					//alert("running to: "+this.exchangeratedata.runningTo)
					this.$nextTick(function () {
						this.initDt()
					});
					this.stopLoader();
				}).catch(err => {
					this.errorMessage("An Error Occured. " + err);
					//this.tableRefreshed(this.defaultListResult);
					this.stopLoader();
				});


		},
		initDt() {
			var cmp = this.loggedInCompany.name + " Exchange Rates";
			var cmp_logo = this.loggedInCompany.logo;
			$('#datatable').DataTable({
				dom: 'Blfrtip',
				buttons: [
					{
						extend: 'csv',
						messageTop: cmp,
						title: function () {
							return cmp;
						},
					},
					{
						extend: 'pdfHtml5',
						title: function () {
							return cmp;
						},
						orientation: 'portrait',
						pageSize: 'A4', // You can also use "A1","A2" or "A3", most of the time "A3" works the best.
						customize: function (doc) {
							doc.defaultStyle.fontSize = 10; //2, 3, 4,etc
							doc.styles.tableHeader.fontSize = 10; //2, 3, 4, etc
							//doc.content[1].table.widths = Array(doc.content[1].table.body[0].length + 1).join('*').split('');
						},
						text: '<i class="fa fa-file-pdf-o"> PDF</i>',
						titleAttr: 'PDF',
						messageBottom: 'This report was generated By ' + this.loggedInUser,
					}
				]
			});
		},
	},

	created() {
		this.startTimer();
		let self = this;
		this.newbackofficeurl = self.$newbackofficeurl;

		this.getLoggedInCompany();
		this.deleteEvent = 'deactivateSelectedRates';
		this.refreshListEvent = 'refreshExRates';
		this.$on(this.refreshListEvent, this.refreshExRates);
		this.$on(this.deleteEvent, this.deactivateSelectedRates);
		this.refreshExRates();
	},
	mixins: [PermissionsMixins]
}
</script>

<style>
table.dataTable tbody tr,
.dataTables_length select,
.dataTables_length select option {
	background-color: #191d24;
}

table.dataTable {
	margin-left: 0px;
	text-align: left;
}

.dataTables_filter label,
.dataTables_wrapper .dataTables_filter input,
.dataTables_length select,
.dataTables_length label {
	color: white !important;
}

.dataTables_wrapper .dataTables_filter input ::placeholder,
.dataTables_wrapper .dataTables_filter input ::-ms-input-placeholder {
	color: white !important;
}

.dataTables_wrapper .dataTables_paginate a.paginate_button {
	color: white !important;
}

.table thead tr,
.table .tbody,
.table .tbody tr {
	white-space: nowrap;
}

.table thead tr th {
	padding: 5px 17px;
	padding-left: 5px;
	background-color: #1b1f27;
	font-weight: bold;
	color: rgba(255, 255, 255, 0.4);
}
</style>